<div class="row pt-2" style="position: relative">

  <div class="col-12 card panel-finalizar ">

    <div class="card-body">

      <div>
        <h3 class="pt-2 card-title">Finalizar pedido<ng-container *ngIf="apenasAgendamento"> (apenas agendamento)</ng-container></h3>

        <form class="k-form" [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
              novalidate #frm="ngForm" (ngSubmit)="fazerPedido()"  [hidden]="pedido.codigo">

          <ng-container *ngIf="!pedido.mesa">
            <h4 class="mt-3">Entrega</h4>

            <p *ngIf="empresa.id && !empresa.formasDeEntrega.length" class="text-muted">Nenhuma forma de entrega está disponível no momento</p>
            <div class="form-group mb-2 escolher">
              <ng-container *ngFor="let formaEntrega of formasDeEntrega;let i = index;">
              <span [ngClass]="{'selecionado': pedido.entrega && pedido.entrega.formaDeEntrega ===formaEntrega.nome}" class="radio radio-blue mb-2"
                    *ngIf="formaEntrega.ativa">
                  <input id="formaDeEntrega{{i}}" name="formaDeEntrega{{i}}" type="radio" class="k-radio" kendoRadioButton
                         (change)="alterouFormaEntrega(formaEntrega)"
                         [(ngModel)]="pedido.entrega.formaDeEntrega" [value]="formaEntrega.nome"
                         [required]="true"/>
                  <label for="formaDeEntrega{{i}}" class="ml-1 d-inline ">{{formaEntrega.nome}}</label>
              </span>
              </ng-container>

              <div class="invalid-feedback" *ngIf="!pedido.entrega.formaDeEntrega">
                <p>Escolha a forma de retirada do seu pedido</p>
              </div>
            </div>

            <div class="form-group col   " *ngIf=" pedido.entrega?.ehRetirada()"     >
              <div class="alert alert-danger"  *ngIf="!pedido.temValorMinimo(FormaDeEntrega.RETIRAR, empresa.formasDeEntrega)">
                <p>Valor mínimo do pedido para retirar é de
                  {{pedido.obtenhaValorMinimoParaEntrega(FormaDeEntrega.RETIRAR, empresa.formasDeEntrega) | currency: "BRL"}} </p>
              </div>

              <div class="alert alert-danger"  *ngIf="pedido.ultrapassouValorMaximo(FormaDeEntrega.RETIRAR, empresa.formasDeEntrega)">
                <p>Valor máximo do pedido para retirar é de
                  {{pedido.obtenhaValorMaximoParaEntrega(FormaDeEntrega.RETIRAR, empresa.formasDeEntrega) | currency: "BRL"}} </p>
              </div>

            </div>

            <div class="form-group col mt-2" *ngIf="pedido.entrega?.ehDelivery()">
              <label>Endereço</label>

              <div   *ngIf="pedido.temValorMinimo(FormaDeEntrega.RECEBER_EM_CASA, empresa.formasDeEntrega) &&
                            !pedido.ultrapassouValorMaximo(FormaDeEntrega.RECEBER_EM_CASA, empresa.formasDeEntrega)">
                <i class="fe-map-pin fa-lg" aria-hidden="true"></i>

                <a    class="text-blue cpointer ml-2" *ngIf="!pedido.entrega?.endereco" (click)="abraModalEscolherEndereco()"><b>Adicionar</b></a>

                <span *ngIf="pedido.entrega?.endereco"  >

                 <div class="d-inline ml-2">
                    {{pedido.entrega.endereco.obtenhaEnderecoCompleto()}}
                   <a    class="text-blue cpointer ml-2"  (click)="abraModalEscolherEndereco()"><b>Trocar</b></a>
                 </div>
               </span>
              </div>

              <div class="alert alert-danger"  *ngIf="empresa.id && !pedido.temValorMinimo(FormaDeEntrega.RECEBER_EM_CASA, empresa.formasDeEntrega)">
                <p>Valor mínimo do pedido para entrega é de
                  {{pedido.obtenhaValorMinimoParaEntrega(FormaDeEntrega.RECEBER_EM_CASA, empresa.formasDeEntrega) | currency: "BRL"}} </p>
              </div>

              <div class="alert alert-danger"  *ngIf="empresa.id && pedido.ultrapassouValorMaximo(FormaDeEntrega.RECEBER_EM_CASA, empresa.formasDeEntrega)">
                <p>Valor máximo do pedido para entrega é de
                  {{pedido.obtenhaValorMaximoParaEntrega(FormaDeEntrega.RECEBER_EM_CASA, empresa.formasDeEntrega) | currency: "BRL"}} </p>
              </div>


            </div>

         </ng-container>

          <span [hidden]="!pedido.temValorMinimoDaFormaEscolhida(empresa.formasDeEntrega) || pedido.ultrapassouValorMaximoDaFormaEscolhida(empresa.formasDeEntrega)">
            <ng-container *ngIf="!pedido.mesa">
              <div class="col mb-3" *ngIf="pedido.entrega && pedido.entrega.taxaDeEntrega >= -1">
                <p class=" mb-0">
                  Taxa de Entrega
                </p>
                <h5 class="mt-1" *ngIf="pedido.entrega.taxaDeEntrega !== -1">
                  {{pedido.obtenhaValorTaxaEntrega() | currency: 'BRL'}}
                </h5>
                <h5 class="mt-1" *ngIf="pedido.entrega.taxaDeEntrega === -1">
                  A Informar
                </h5>
              </div>
             <ng-container *ngIf="pedido.entrega">
                <app-agendar-entrega [tela]="this" [pedido]="pedido" [empresa]="empresa"
                                     [agendarEntrega]="agendouEntrega || apenasAgendamento"
                                     [apenasAgendamento]="apenasAgendamento"
                                      [formasDeEntrega]="formasDeEntrega">

                </app-agendar-entrega>


                <div class="invalid-feedback" *ngIf="agendarEntrega && (!pedido.dataEntrega || !pedido.horarioEntrega)">
                  <p>É necessário escolher o dia e horário da entrega</p>
                </div>
             </ng-container>


              <hr class="linha">

              <h4 class="mb-2"  >Pagamento</h4>

              <ng-container *ngIf="formasDePagamentoPix.length > 0 && estaHabilitado(formasDePagamentoPix[0], pedido)">
                <div class="form-group mb-3 mt-2 escolher">
                  <div class="mr-3 radio radio-blue mb-1"
                       *ngFor="let formaDePagamento of formasDePagamentoPix">
                    <h5>Pagar Agora Via Pix</h5>
                    <img src="https://user-images.githubusercontent.com/33992396/99478353-00e4d600-2933-11eb-8228-4bafe8571507.png" style="width: 32px;" class="mr-1"/>
                    <input [id]="'formaPagamento' + formaDePagamento.id" name="formaDePagamento" type="radio"    kendoRadioButton
                           [(ngModel)]="pedido.pagamento.formaDePagamento" [value]="formaDePagamento" class="k-radio"
                           (ngModelChange)="alterouFormaDePagamentoParaPix()"
                           [required]="true"/>
                    <label for="formaPagamento{{formaDePagamento.id}}" class="ml-1 d-inline">
                      {{formaDePagamento.descricao}}

                      <span class="text-muted float-right" *ngIf="formaDePagamento.taxaCobranca && formaDePagamento.taxaCobranca.ativa">
                       <i>+{{formaDePagamento.taxaCobranca.percentual}}% taxa</i></span>
                    </label>
                  </div>

                  <div class="invalid-feedback" *ngIf="!pedido.pagamento.formaDePagamento">
                    <p>Escolha a forma de pagamengo do seu pedido</p>
                  </div>
                </div>

                <div class="form-group" *ngIf="pedido.pagamento.formaDePagamento && pedido.pagamento.formaDePagamento.pix">
                  <h5 for="trocoParaM">Informe seu Email</h5>
                  <div class="input-group">
                     <input id="emailPix" name="emailPix"  class="form-control" #txtEmailPix  email="true" type="email"
                            #emailPix="ngModel" placeholder="Informe seu email" [required]="true"
                            [(ngModel)]="pedido.pagamento.dadosPix.email"  />
                      <div class="invalid-feedback">
                        <p *ngIf="emailPix.errors?.required">
                          Para pagamentos pix você deve informar seu email. Caso aconteça algum problema, usaremos esse email para te contactar.
                        </p>

                        <p *ngIf="emailPix.errors?.email">Informe um email válido.</p>

                      </div>
                  </div>

                </div>
              </ng-container>

              <ng-container *ngIf="cashback &&  cashback.podeUsarNaLoja" >
                <h5  > Usar meu <b>saldo de cashback</b> para pagar </h5>
                <div class="k-display-inline-flex  pagarfidelidade" [ngClass]="{'gendai': empresa.idRede === 2}">
                  <div class="flex-row">

                     <a  (click)="abraModalAtualizarCadastro()" *ngIf="cashback.atualizarCadastro" href="">
                      <b>Atualizar meu cadastro </b>
                       <br>
                      <small class="text-muted">Atualize seu cadastro para utilizar seu cashback</small>
                     </a>

                     <a  (click)="abraModalLogin()" *ngIf="cashback.fazerLogin" href="">
                      <b>Identifique-se</b>
                       <br>
                      <small class="text-muted">Faça login para utilizar seu cashback </small>
                     </a>

                     <a  (click)="abraModalFazerOptin()" *ngIf="cashback.fazerOptin ||  cashback.fazerOptinUsarSaldo" href="">
                        <b>Quero ganhar cashback</b>
                         <br>
                        <small class="text-muted">Participe do plano fidelidade para ganhar até 20% de cashback</small>
                     </a>

                    <div class="form-group mb-2 mt-2" [hidden]="cashback.atualizarCadastro || cashback.fazerLogin || cashback.fazerOptin ||  cashback.fazerOptinUsarSaldo">
                        <input id="usarSaldo" name="usarSaldo" type="checkbox"    kendoCheckBox (change)="alterouUsarSaldo()"
                               [(ngModel)]="cashback.usar"      class="k-checkbox" [disabled]="!cashback.podeUsar || !cashback.podeUsarNoPedido  "/>
                        <label for="usarSaldo" class="ml-1 usar-saldo"  >
                          Saldo cashback disponível <span class="preco"><b>{{  obtenhaSaldo()}}</b></span>
                        </label>

                          <p class="mt-1" *ngIf="!cashback.podeUsar" >
                            <i class="fa fa-exclamation-circle mr-1 text-warning "></i>
                            Acumule <span class=" text-blue"><b>{{ cashback.minimo | currency:"BRL"}}</b></span> de saldo
                            e utilize como forma de pagamento.</p>

                           <p class="mt-1" *ngIf="cashback.podeUsar && !cashback.podeUsarNoPedido" >
                            <i class="fa fa-exclamation-circle mr-1 text-warning "></i>
                            Faça um pedido a partir de <span class=" text-blue"><b>{{ cashback.minimoPedido | currency:"BRL"}}</b></span>
                            e utilize seu saldo como forma de pagamento.</p>


                </div>
                  </div>
                  <div class="flex-row">
                   <img src="{{empresa.integracaoFidelidade?.logo}}" class="ml-2 imagem-programa" style="max-height: 40px;"
                        *ngIf="empresa.integracaoFidelidade?.logo">
                  </div>
                </div>

                <div class="produto pt-0 pb-2"  [hidden]="obtenhaTotalPagar() === 0" >
                  <div class="media mt-2">
                    <div class="media-body">
                      <h5 class="mt-0 mb-1"> Total restante a pagar

                      <span class="preco font-15"><b>{{obtenhaTotalPagar() | currency: 'BRL'}}</b></span></h5>
                    </div>

                  </div>
                </div>

             </ng-container>

              <ng-container *ngIf="obtenhaTotalPagar() > 0 ">
                 <div *ngIf="!empresa.formasDePagamento?.length" class="alert alert-info">
                   Nenhuma forma de pagamento disponível
                 </div>
                                  <h5 *ngIf="formasDePagamentoOnline.length > 0">Pagar Agora Online:</h5>

                  <div class="form-group mb-2 mt-2 escolher row">
                    <div class="col-6 radio radio-blue mt-1"
                         *ngFor="let formaDePagamento of formasDePagamentoOnline">
                                              <span class="radio radio-blue" [hidden]="!estaHabilitado(formaDePagamento, pedido)" [ngClass]="{'selecionado': pedido.pagamento?.formaDePagamento?.id === formaDePagamento.id }">
                      <input id="formaPagamento{{formaDePagamento.id}}" name="formaDePagamento" type="radio"    kendoRadioButton
                             [(ngModel)]="pedido.pagamento.formaDePagamento" [value]="formaDePagamento" class="k-radio"
                             [required]="true" (ngModelChange)="escolheuFormaDePagamentoOnline(formaDePagamento)"
                             #rdFormaDePagamento="ngModel"
                             [pagseguro]="{pedido: pedido, exigeCartao: exigeCartao, dadosCartao: dadosCartao}"/>

                      <label for="formaPagamento{{formaDePagamento.id}}" class="ml-1 d-inline">{{formaDePagamento.descricao}}

                        <span class="text-muted font-11 ml-1 d-inline" *ngIf="formaDePagamento.taxaCobranca && formaDePagamento.taxaCobranca.ativa"
                        >(+{{formaDePagamento.taxaCobranca.percentual}}% taxa)</span>

                      </label>


                        </span>

                      <ng-container *ngIf="rdFormaDePagamento.errors">
                        <div class="invalid-feedback" *ngIf="rdFormaDePagamento?.errors?.endereco_obrigatorio">
                            <p>Para retirada, você deve preencher o endereço do dono do cartão de crédito</p>
                        </div>
                      </ng-container>
                      <div class="invalid-feedback" *ngIf="rdFormaDePagamento?.errors?.dados_cartao_obrigatorio">
                        <p>Você deve informar os dados do cartão de crédito para fazer o pedido.</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12" *ngIf="pedido.pagamento && exigeCartao">
                      <ng-container *ngIf="pedido.pagamento.dadosCartao">
                        <i class="fas fa-credit-card font-16"></i>
                        <span>&nbsp; ************{{pedido.pagamento.dadosCartao.ultimosNumeros}}</span>
                        <button type="button" class="btn btn-blue btn-sm ml-2" (click)="trocarCartao()">
                          <i class="far fa-credit-card  mr-1 fa-lg"></i>
                          Trocar Cartão</button>
                      </ng-container>
                       <ng-container *ngIf="!pedido.pagamento.dadosCartao && pedido.entrega.formaDeEntrega">
                          <button class="btn btn-blue btn-sm ml-2" type="button" (click)="trocarCartao()">
                            <i class="far fa-credit-card mr-1 fa-lg"></i>
                            Adicionar Cartão</button>
                        </ng-container>
                    </div>
                 <h5 class=""  [hidden]="!formasDePagamento?.length" >Pagar na Entrega:  </h5>

                  <div class=""  >
                    <div class="form-group mb-2 mt-2 escolher row">
                      <ng-container *ngFor="let formaDePagamento of formasDePagamento">
                      <div class="col-6 radio radio-blue mt-1"  [hidden]="!estaHabilitado(formaDePagamento, pedido)">
                        <span class="radio radio-blue"   [ngClass]="{'selecionado': pedido.pagamento?.formaDePagamento?.id === formaDePagamento.id }">
                            <input [id]="'formaPagamento' + formaDePagamento.id" name="formaDePagamento" type="radio"    kendoRadioButton
                                   [(ngModel)]="pedido.pagamento.formaDePagamento" [value]="formaDePagamento" class="k-radio"
                                   #formaDePagamento="ngModel"
                                   [required]="true"  (ngModelChange)="escolheuFormaDePagamentoPresencial(formaDePagamento)"/>
                            <label for="formaPagamento{{formaDePagamento.id}}" class="ml-1 d-inline">{{formaDePagamento.descricao}}

                            </label>
                            <label class="text-muted font-11 ml-1 d-inline" *ngIf="formaDePagamento.taxaCobranca && formaDePagamento.taxaCobranca.ativa"
                            >(+{{formaDePagamento.taxaCobranca.percentual}}%)</label>

                          <label class="text-muted font-11 ml-1 d-inline" *ngIf="formaDePagamento.possuiDesconto && formaDePagamento.desconto > 0"
                          >(-{{formaDePagamento.desconto}}% taxa)</label>
                           </span>
                      </div>
                      </ng-container>

                    </div>

                    <ng-container *ngIf="pedido.pagamento?.formaDePagamento?.nome === 'dinheiro'" >
                        <div  class="col ml-3" >
                          <h6 class="mt-3"  >Vai precisar de troco?  </h6>

                          <div class="form-group escolher troco">

                        <span [ngClass]="{'selecionado': pedido.pagamento.temTroco==='sim' }" class="radio radio-blue">
                          <input id="trocoSim" name="temTroco" type="radio"    kendoRadioButton class="k-radio"
                                 [(ngModel)]="pedido.pagamento.temTroco" value="sim"
                                 [required]="pedido.pagamento?.formaDePagamento?.nome === 'dinheiro'"/>
                          <label for="trocoSim" class="ml-1">&nbsp;Sim</label>

                        </span>

                          <span [ngClass]="{'selecionado': pedido.pagamento.temTroco=== 'nao' }" class="radio radio-blue">
                          <input id="trocoNao" name="temTroco" type="radio"    kendoRadioButton class="k-radio"
                                 [(ngModel)]="pedido.pagamento.temTroco" value="nao" (ngModelChange)="mudouPrecisaTroco(formaDePagamento)"
                                 [required]="pedido.pagamento?.formaDePagamento?.nome === 'dinheiro'"/>
                          <label for="trocoNao" class="ml-1">&nbsp;Não</label>

                        </span>

                        <div class="invalid-feedback" *ngIf="!pedido.pagamento.temTroco">
                            informe se vai precisar de troco.
                        </div>
                      </div>
                        </div>
                        <div class="form-group col  ml-3" *ngIf="pedido.pagamento.temTroco ==='sim'">
                          <h6 for="trocoParaM">Troco para quanto?</h6>
                          <input id="trocoParaM" name="trocoParaM" type="text" inputmode="decimal" class="form-control troco" #txtTrocoM="ngModel"
                                 trocoMinimo="{{obtenhaTotalPagar()}}"
                                 (ngModelChange)="calculeTroco($event)" appSelecionarNoFoco
                                 [(ngModel)]="pedido.pagamento.trocoPara"
                                 currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }"/>

                          <div class="invalid-feedback">
                            <p *ngIf="txtTrocoM.errors?.trocoMinimo">
                              A nota tem que ser maior que  {{obtenhaTotalPagar() | currency: "R$"}}</p>
                          </div>
                        </div>
                    </ng-container>
                  </div>


                  <hr class="linha">
             </ng-container>
            </ng-container>

            <div class="invalid-feedback" *ngIf="!pedido.pagamento.formaDePagamento">
            <p>Escolha a forma de pagamento do seu pedido</p>
            </div>

            <ng-container *ngIf="exigeCartao && !pedido.pagamento.dadosCartao && !pedido.entrega.formaDeEntrega">
            <div class="alert alert-warning">
              <span>Selecione a Forma de Entrega Antes de Adicionar os dados de cartão</span>
            </div>
            </ng-container>

            <div *ngFor="let campoAdicional of camposAdicionais; let posicao = index">
            <app-site-campo-adicional #adicionalComponent [id]="'adicional_' + campoAdicional.id" [campoAdicional]="campoAdicional"
                                      [itemPedido]="pedido" [posicao]="campoAdicional.posicao"></app-site-campo-adicional>
            </div>

            <ng-container *ngIf="exibirDadosCliente()">
                 <h4 class="mt-3"> Dados do cliente: </h4>

                <div class="form-group mb-1 col col-md-6">
                  <label for="telefone">Telefone</label>
                  <div class="input-group ">
                    <div style="display: flex">
                    <app-seletor-codigo-pais
                     [selectedCountryCode]="pedido.contato.codigoPais ? pedido.contato.codigoPais : '+55' "
                      (phoneMaskChange)="onPhoneMaskChange($event)"
                      (selectedCountryCodeChange)="onCountrySelected($event)"></app-seletor-codigo-pais>

                    <kendo-maskedtextbox  id="telefone" name="telefone"  #telefone="ngModel" [mask]="phoneMask" (change)="informouTelefone()"
                                          #kendoMaskedTextBox="kendoMaskedTextBox"
                           class="form-control ml-1"  [disabled]="buscando"
                           [(ngModel)]="pedido.contato.telefone"   required>
                      </kendo-maskedtextbox>

                    </div>

                    <div class="invalid-feedback">
                      <p *ngIf="telefone.errors?.required">Telefone é obrigatório</p>
                      <p *ngIf="telefone.errors?.patternError">Telefone inválido</p>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <label for="nome">Nome </label>
                  <input kendoTextBox id="nome" name="nome"  placeholder="Nome completo"
                         class="form-control"   #nome="ngModel"
                         [(ngModel)]="pedido.contato.nome" required/>

                  <div class="invalid-feedback">
                    <p *ngIf="nome.errors?.required">Nome é obrigatório</p>
                  </div>
                </div>

                <div class="form-group mb-2 col" *ngIf="informarCpf">
                  <label  >CPF</label>
                  <input type="text" class="form-control" autocomplete="off"
                         name="cpf" [(ngModel)]="pedido.contato.cpf" #cpf="ngModel" mask="000.000.000-00" cpfValido
                         placeholder="___.___.___-__"   [required]="cpfObrigatorio"  (change)="informouCpf()">
                  <div class="invalid-feedback">
                    <p *ngIf="cpf.errors?.required">CPF é obrigatório</p>
                    <p *ngIf="!cpf.errors?.required && cpf.errors?.cpfInvalido">CPF inválido</p>
                  </div>
                </div>

                 <div class="form-group mb-2 col col-md-6" *ngIf="informarDataNascimento">
                    <label  >Data Nascimento</label>
                  <kendo-datepicker #dataNascimento='ngModel' [(ngModel)]="pedido.contato.dataNascimento"
                                    class="form-control "   format="dd/MM/yyyy"  activeView="decade"
                                    name="dataNascimento" activeView="decade"
                                    [required]="dataNascimentoObrigatorio"     >
                    <kendo-datepicker-messages
                      today="Hoje"
                      toggle="Trocar calendário"
                    ></kendo-datepicker-messages>

                  </kendo-datepicker>

                     <div class="invalid-feedback">
                        <p *ngIf="dataNascimento.errors?.required">Data de nascimento é obrigatória</p>

                    </div>

                 </div>

                <div class="form-group mb-2 col aceite-fidelidade" *ngIf="fidelidadeExterna && fidelidadeExterna.aceitarFidelidade">
                    <input  id="optin" name="optin" type="checkbox"    kendoCheckBox
                            [(ngModel)]="fidelidadeExterna.optin"      class="k-checkbox" (change)="alterouOptinFidelidade()" />
                        <label for="optin" class="ml-1 usar-saldo"  >
                         Quero ganhar cashback com {{empresa.idRede === 1 ? 'Meu China in Box' : 'Gendai Vip'}}
                          <img src="{{fidelidadeExterna.logo}}" class="ml-2" *ngIf="fidelidadeExterna.logo" style="max-height: 40px">

                          <br>
                          <span class="ml-3"> Estou de acordo com o  <a href="{{fidelidadeExterna.linkRegras}}"  target="_blank">Regulamento</a>.</span>
                        </label>

                </div>

                <span *ngIf="criarConta || fidelidadeExterna?.optin">
                  <fieldset>
                    <legend>Dados de acesso</legend>
                    <div class="form-group mb-2">
                      <label for="email">E-mail </label>
                      <input type="email" class="form-control" autocomplete="off" [required]=" true" email = true
                             id="email" name="email"  [(ngModel)]="pedido.contato.email" #email="ngModel"
                             placeholder="Email do usuário"   >
                      <div class="invalid-feedback">
                        <p *ngIf="email.errors?.required" >Email é obrigatório</p>
                      </div>
                    </div>

                    <div class="form-group mb-2"  >
                      <label for="senha">Senha</label>
                      <label   class="col-form-label float-right cpointer text-blue" (click)="exibirSenhaTela()">
                        <i class="fa fa-eye fa-lg   " *ngIf="!exibirSenha"></i>
                        <i class="fa fa-eye-slash fa-lg   " *ngIf="exibirSenha"></i>
                      </label>
                      <span *ngIf="!exibirSenha">
                          <input class="form-control" type="password"  id="senha" name="senha"  #senha="ngModel"
                                 [(ngModel)]="pedido.contato.senha" placeholder="Informe sua senha"  [required]=" true">
                          <div  class="invalid-feedback">
                            <p  *ngIf="senha.errors?.required">Senha é obrigatório</p>
                          </div>
                      </span>

                      <span *ngIf="exibirSenha">
                          <input class="form-control" type="text"  id="senhaTexto" name="senhaTexto"  #senhaTexto="ngModel"
                                 [(ngModel)]="pedido.contato.senha" placeholder="Informe sua senha"  [required]=" true">
                          <div  class="invalid-feedback">
                            <p  *ngIf="senhaTexto.errors?.required">Senha é obrigatório</p>
                          </div>
                      </span>

                    </div>
                  </fieldset>
                </span>
            </ng-container>

            <ng-container  *ngIf="pedido.maisDeUmaFormaPagamento()">
              <div class="media-body" >
              <h5 class="mt-0 mb-1"><span>Formas De Pagamento:</span></h5>
            </div>
            <div class="clearfix"></div>
            <div class="  mt-2 d-flex flex-column w-100"  >

            <h5 class="mt-0    flex-row text-right"  >
              <strong>Fidelidade Cashback:
                <span class="preco">  {{obtenhaSaldo()}} </span>
               </strong>
            </h5>


            <h5 class="mt-0 text-right  flex-row " *ngIf="pedido.pagamento?.formaDePagamento">
              <strong>{{  pedido.pagamento.formaDePagamento.descricao}}:
                <span class="preco">  {{ pedido.obtenhaValorAhPagar() | currency: "BRL"}}</span>
             </strong>
            </h5>
            </div>


            </ng-container>

            <div class="col mt-2 mb-2"  *ngIf="msgErro">
                      <div class="alert alert-danger " role="alert" >
                      <i class="fas fa-exclamation-triangle"></i> {{msgErro}}
                     </div>
            </div>

            <div class="col mt-4"  *ngIf="!criarConta && !pedido.contato.id && !fidelidadeExterna?.optin">

            <button class="btn btn-blue  btn-block "  type="submit" *ngIf="!pedido.codigo" [disabled]="eviandoPedido || buscando">
            <i class="k-icon k-i-loading mr-1" *ngIf="eviandoPedido"></i>
            Fazer Pedido sem Criar Conta</button>

            <button class="btn  btn-primary btn-block  " type="button" (click)="exibirCriarConta()" [disabled]="eviandoPedido || buscando">
            Criar conta</button>



            </div>

            <div class="mt-3" *ngIf="criarConta || pedido.contato.id || fidelidadeExterna?.optin">
            <button class="btn btn-blue btn-block "  type="submit" *ngIf="!pedido.codigo" [disabled]="eviandoPedido || buscando">
            <i class="k-icon k-i-loading mr-1" *ngIf="eviandoPedido"></i>
            Fazer pedido </button>

            <button class="btn btn-light btn-block mb-2 mt-2" *ngIf="criarConta" type="button" [disabled]="eviandoPedido || buscando"
                   (click)="canceleCriarConta()" >Voltar</button>

            </div>

          </span>

        </form>

      </div>

    </div>

  </div>

  <div class="col-8 panel-pedido">

    <app-loja-carrinho #panelCarrinho    ></app-loja-carrinho>
  </div>
</div>


<div id="alertaGerandoPagamento" class="modal fade" tabindex="-1" role="dialog"   aria-modal="true" data-backdrop="static">
  <div class="modal-dialog ">
    <div class="modal-content">
      <div class="modal-body p-4">
        <div class="text-center">

          <ng-container *ngIf="!msgErroLink">
            <h4 class="mt-2">
              <i class="k-icon k-i-loading mr-1"></i>
              Aguarde que você será redirecionado para tela de  pagamento.</h4>
          </ng-container>

          <ng-container *ngIf="msgErroLink">

            <i class="k-icon k-i-error mr-1"></i> Falha ao gerar link de pagamento:
            <br>
            <b>{{msgErroLink}}</b>
            <br> <br>
            <button class="btn btn-blue mt-1 " (click)="gereLinkPagamento()">Tentar de novo</button>

          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
